import { render } from "./EditPetDashboard.vue?vue&type=template&id=5825b038&scoped=true"
import script from "./EditPetDashboard.vue?vue&type=script&lang=js"
export * from "./EditPetDashboard.vue?vue&type=script&lang=js"

import "./EditPetDashboard.vue?vue&type=style&index=0&id=5825b038&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5825b038"]])

export default __exports__